import { gql } from "urql";

export const drgSetFindingDispositionMutationDoc = gql`
  mutation drgSetFindingDisposition($input: DrgSetFindingDispositionInput!) {
    drgSetFindingDisposition(input: $input) {
      id
      claimId
      module
      verdict
      code
      codeDescription
      detectedRole
      confidence
      poaValue
      poaCitationPage
      agentName
      agentDiagnosisType
      agentGovernedCodes
      agentRunId
      aiNarrative
      clinicalFindings
      disposition
      dispositionActor {
        id
        email
        displayName
        orgId
      }
      dispositionAt
      author {
        __typename
        ... on DrgUser {
          id
          displayName
        }
        ... on DrgAgent {
          id
          name
        }
      }
      supportingEvidence {
        id
        kind
        title
        description
        sourceType
        evidenceDate
        citationPage
        disqualifiesAs
      }
      disqualifyingEvidence {
        id
        kind
        title
        description
        sourceType
        evidenceDate
        citationPage
        disqualifiesAs
      }
      proposedChange {
        removeCodes
        addCodes {
          code
          role
          rationale
        }
        reposition {
          code
          fromPosition
          toPosition
        }
      }
      pinnedEvidenceIds
      linkedAnnotationCount
      createdAt
      updatedAt
    }
  }
`;
